<template>
  <b-modal
    ref="modal"
    v-model="isShown"
    :title="$t('views.template_list.event_settings')"
    modal-class="spdo-modal"
    hide-header-close
    hide-footer
    centered
    size="lg"
    @shown="getEvent"
    @hidden="hideModal"
  >
    <v-form @submit.prevent="submit">
      <div class="v-application spdo-modal__body pt-0">
        <div class="input-block input-block_white">
          <label class="input-block__label">
            {{ $t('views.template_list.event_type') }}
          </label>
          <v-select
            v-model="event.type"
            :items="Object.values(EventTypes)"
            hide-details
            solo
          />
        </div>

        <div class="input-block input-block_white">
          <!-- eslint-disable max-len -->
          <div
            class="custom-control custom-checkbox d-flex spdo-custom-control spdo-custom-control_white"
          >
            <input
              id="event-savedb"
              v-model="event.saveDb"
              type="checkbox"
              class="custom-control-input"
            >
            <label
              for="event-savedb"
              class="custom-control-label"
            >
              {{ $t('views.template_list.save_db') }}
            </label>
          </div>
          <!-- eslint-enable max-len -->
        </div>

        <div
          v-for="option of event.options"
          :key="option.name"
          class="input-block input-block_white"
        >
          <label class="input-block__label">{{ option.name }}</label>
          <v-text-field
            v-if="option.type === OptionTypes.Number"
            v-model="option.value"
            type="number"
            hide-details
            solo
          />
          <v-select
            v-else-if="option.type === OptionTypes.RoleList"
            v-model="option.value"
            :items="contactRoles
              .map((role) => ({ role, label: $t(`enums.supplier_notification_roles.${role}`) }))"
            item-text="label"
            item-value="role"
            multiple
            clearable
            hide-details
            solo
          />
        </div>
      </div>

      <div class="v-application d-flex">
        <v-btn
          class="mr-4 flex-grow-1"
          outlined
          large
          :disabled="loading"
          @click="hideModal"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          class="flex-grow-1"
          :loading="loading"
          outlined
          large
          type="submit"
        >
          {{ $t('common.save') }}
        </v-btn>
      </div>
    </v-form>
  </b-modal>
</template>

<script>
import { contactRoles } from '@/utils/enums';

export default {
  name: 'EventSettings',

  model: {
    prop: 'value',
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },

    selectedEvent: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      event: {
        name: '',
        saveDb: false,
        type: '',
        options: [],
      },

      loading: false,
      isShown: false,

      EventTypes: {
        system: 'system',
        business: 'business',
      },

      OptionTypes: {
        Number: 'Number',
        RoleList: 'RoleList',
      },

      contactRoles,
    };
  },

  watch: {
    value(val) {
      this.isShown = val;
    },
  },

  methods: {
    getEvent() {
      this.event = {
        ...this.selectedEvent,
        options: this.selectedEvent.options.map((option) => ({ ...option })),
      };
    },

    hideModal() {
      this.$emit('input', false);
    },

    async submit() {
      this.loading = true;
      try {
        await this.$http.post('/events', this.event);
        this.hideModal();
        this.$emit('submit');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
